@if (dataTableContext.selectable()) {
    <td class="wk-data-table__cell wk-data-table__cell--selectable" [class.wk-data-table__cell--locked]="hasLockedColumns()">
        @if (!empty() && item()) {
            <checkbox-field-pds3>
                <input type="checkbox" [checked]="item()?.$selected ?? false" (keydown)="toggleSelect()" (change)="toggleSelect()" />
            </checkbox-field-pds3>
        }
    </td>
}
@for (column of columns(); track column.fullFieldName()) {
    <td wk-data-table-cell [index]="index()" [columnIndex]="$index" [fieldname]="column.fullFieldName()"></td>
}

@if (dataTableContext.actions().length) {
    <td class="wk-data-table__cell wk-data-table__cell--actions">
        @if (!empty() && item() && dataTableContext.actions()(item()).length) {
            <icon-pds3 name="wk-icon-filled-more" />
            <dropdown-pds3 [targetSelector]="`#${id()} .wk-data-table__cell--actions`">
                <dropdown-list-pds3>
                    @for (action of dataTableContext.actions()(item()); track $index) {
                        <dropdown-item-field-pds3
                            *dropdownListItemPds3
                            (click)="action.event(item())"
                            (keydown.enter)="action.event(item())"
                            aria-hidden="true"
                        >
                            <button
                                type="button"
                                class="wk-data-table__action-button"
                                [class]="'wk-data-table__action-button--' + action.type.toLowerCase()"
                            >
                                <icon-pds3 [name]="`wk-icon-${action.icon}`" />
                                {{ action.title }}
                            </button>
                        </dropdown-item-field-pds3>
                    }
                </dropdown-list-pds3>
            </dropdown-pds3>
        }
    </td>
}
